import { render, staticRenderFns } from "./TournamentLink.vue?vue&type=template&id=6fec6016"
import script from "./TournamentLink.vue?vue&type=script&lang=js"
export * from "./TournamentLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports